(function () {
  'use strict';
  if (window.__phSnapmintFix) return;
  window.__phSnapmintFix = true;

  function parseAmount(text) {
    if (!text) return 0;
    return parseInt(String(text).replace(/[^\d.-]/g, ''), 10) || 0;
  }

  function collectionPrice(widget) {
    var priceNode = widget.querySelector('.dp-collection-price');
    var fromData = priceNode ? parseAmount(priceNode.getAttribute('data-price')) : 0;
    if (fromData) return fromData;

    var card = widget.closest('.custom-card, .product-card, .ph-card, article, .swiper-slide');
    if (card) {
      var cardPrice = parseAmount(card.getAttribute('data-ph-emi-price'));
      if (cardPrice) return cardPrice;
    }
    var priceEl = card
      ? card.querySelector('.custom-card__price--new, .ph-price-new')
      : null;
    return parseAmount(priceEl ? priceEl.textContent : '');
  }

  function preparePdpContext(price) {
    var host = document.querySelector('[data-ph-snap-pdp-proxy]');
    if (!host) {
      host = document.createElement('div');
      host.className = 'product-detail__information';
      host.setAttribute('data-ph-snap-pdp-proxy', 'true');
      host.setAttribute('aria-hidden', 'true');
      host.style.cssText =
        'position:absolute;left:0;top:0;opacity:0.01;z-index:-1;pointer-events:none;width:80px;height:20px;overflow:hidden;';
      host.innerHTML =
        '<div class="product-detail__price">' +
        '<span class="sale-price"></span>' +
        '<span class="original-price"></span>' +
        '</div>';
      document.body.appendChild(host);
    }

    var sale = host.querySelector('.sale-price');
    var original = host.querySelector('.original-price');
    if (sale) sale.textContent = String(price);
    if (original) original.textContent = String(price);

    var btn = document.querySelector('#sm-widget-btn.snap_emi_txt');
    if (!btn) {
      btn = document.createElement('div');
      btn.id = 'sm-widget-btn';
      btn.className = 'snap_emi_txt ph-snapmint-pdp-proxy';
      btn.setAttribute('aria-hidden', 'true');
      btn.style.cssText =
        'position:absolute;left:0;top:0;opacity:0.01;z-index:-1;pointer-events:none;width:80px;height:20px;overflow:hidden;';
      document.body.appendChild(btn);
    }
    btn.setAttribute('data-widget', String(price));
    btn.setAttribute('data-price', String(price));
    return btn;
  }

  function revealPlansPopup() {
    var wrap = document.getElementById('sm-pop-up-model');
    var modal = document.getElementById('snap-modalon_page');
    if (wrap && wrap.parentNode !== document.body) {
      document.body.appendChild(wrap);
    }
    if (!modal) return;
    modal.style.setProperty('display', 'flex', 'important');
    modal.style.setProperty('position', 'fixed', 'important');
    modal.style.setProperty('z-index', '2147483646', 'important');
    modal.style.setProperty('left', '0', 'important');
    modal.style.setProperty('top', '0', 'important');
    modal.style.setProperty('width', '100%', 'important');
    modal.style.setProperty('height', '100%', 'important');
    modal.style.setProperty('align-items', 'center', 'important');
    modal.style.setProperty('justify-content', 'center', 'important');
    modal.style.setProperty('background-color', 'rgba(0,0,0,0.5)', 'important');
  }

  function openLikeViewPlans(price) {
    if (!price) return;
    if (typeof window.startPop !== 'function') {
      window.setTimeout(function () {
        openLikeViewPlans(price);
      }, 200);
      return;
    }

    if (typeof window.updateSnapOptions === 'function') {
      window.updateSnapOptions();
    }

    var stale = document.getElementById('sm-pop-up-model');
    if (stale) stale.remove();

    var btn = preparePdpContext(price);
    var start = window.startPop;
    var original = (start && start.__phOriginal) || start;
    if (typeof original !== 'function' || original === openLikeViewPlans) return;

    if (start) start.__phOpeningCollection = true;
    original.call(window, btn);
    if (start) start.__phOpeningCollection = false;

    window.requestAnimationFrame(revealPlansPopup);
    window.setTimeout(revealPlansPopup, 50);
    window.setTimeout(revealPlansPopup, 300);
  }

  document.addEventListener(
    'click',
    function (event) {
      var widget = event.target.closest('.snap_collection_category');
      if (!widget) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openLikeViewPlans(collectionPrice(widget));
    },
    true
  );

  function patchStartPop() {
    if (typeof window.startPop !== 'function' || window.startPop.__phPatched) {
      return typeof window.startPop === 'function';
    }

    var original = window.startPop;
    function patched(element) {
      if (patched.__phOpeningCollection) {
        return original.call(this, element);
      }

      var isCollectionWidget =
        element &&
        element.querySelector &&
        element.querySelector('.dp-collection-price');

      if (isCollectionWidget) {
        openLikeViewPlans(collectionPrice(element));
        return;
      }

      return original.apply(this, arguments);
    }

    patched.__phPatched = true;
    patched.__phOriginal = original;
    window.startPop = patched;
    return true;
  }

  if (!patchStartPop()) {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (patchStartPop() || tries > 40) window.clearInterval(timer);
    }, 250);
  }

  function disableCartDrawerSnapmint() {
    try {
      snapOptions.shouldHideMiniCartWidget = 'true';
    } catch (e) {}

    window.addminCartLoadPage = function () {
      document.querySelectorAll('.snap_emi_txt_minicart').forEach(function (node) {
        node.remove();
      });
    };

    document.querySelectorAll('.snap_emi_txt_minicart').forEach(function (node) {
      var wrap = node.closest('.snap_dp_list') || node;
      wrap.remove();
    });
  }

  disableCartDrawerSnapmint();
  var hideTries = 0;
  var hideTimer = window.setInterval(function () {
    hideTries += 1;
    disableCartDrawerSnapmint();
    if (hideTries > 40) window.clearInterval(hideTimer);
  }, 250);

  if (typeof MutationObserver !== 'undefined') {
    var cartDrawerObserver = new MutationObserver(function () {
      document.querySelectorAll('.snap_emi_txt_minicart').forEach(function (node) {
        var wrap = node.closest('.snap_dp_list') || node;
        wrap.remove();
      });
    });
    cartDrawerObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
